import { DestinationState } from 'components/search/expedia/interfaces';

const initialDestinationState: DestinationState = {
  destination: '',
};

export { initialDestinationState };
